/**
 * represents Special order parts, which needs to be handled in different manner
 */
export enum SpecialOrderParts {
  Notes = 'Implant Part Notes',
  Amount = 'Implant Part Price',
}
